import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetAdmins = () => {
  return useQuery({
    queryKey: ["admins"],
    queryFn: async () => {
      try {
        const response = await axios.get("/api/sellerprofile/bop", {
          params: {
            page: 1,
            limit: 10000000,
            sortColumn: "date_created",
            sortOrder: "desc",
            status: "",
            search: "",
            "searchObject[country]": "",
            "searchObject[is_verified]": "",
          },
        });
        console.log("Admins API Response:", response.data);
        return response.data;
      } catch (error) {
        console.error("Admins API Error:", error);
        throw error;
      }
    },
    staleTime: 30000,
  });
};

export default useGetAdmins;
